var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvisors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7411 8H7.25895C4.93263 8 3 9.86237 3 12.1816V27.8184C3 30.1025 4.89684 32 7.25895 32H32.7411C35.0674 32 37 30.1376 37 27.8184V12.1464C37 9.86237 35.1032 8 32.7411 8ZM13.6295 13.2006C15.3832 13.2006 16.8147 14.6061 16.8147 16.328C16.8147 18.0498 15.3832 19.4553 13.6295 19.4553C11.8758 19.4553 10.4442 18.0498 10.4442 16.328C10.4442 14.6061 11.8758 13.2006 13.6295 13.2006ZM19.0337 26.7643H8.22526C7.90316 26.7643 7.58105 26.6237 7.40211 26.3777C7.18737 26.1318 7.11579 25.8155 7.22316 25.4993C7.93895 22.5827 10.5874 20.5095 13.6653 20.5095C16.6358 20.5095 19.2126 22.4422 20 25.2533C20.0716 25.3939 20.1074 25.5344 20.1074 25.7101C20.1074 26.3075 19.6421 26.7643 19.0337 26.7643ZM26.3705 22.5827H22.1116C21.5389 22.5827 21.0379 22.1259 21.0379 21.5285C21.0379 20.9663 21.5032 20.4744 22.1116 20.4744H26.3705C26.9432 20.4744 27.4442 20.9312 27.4442 21.5285C27.4442 22.1259 26.9789 22.5827 26.3705 22.5827ZM31.7032 18.4012H22.1116C21.5389 18.4012 21.0379 17.9444 21.0379 17.347C21.0379 16.7848 21.5032 16.2928 22.1116 16.2928H31.6674C32.24 16.2928 32.7411 16.7496 32.7411 17.347C32.7411 17.9444 32.2758 18.4012 31.7032 18.4012Z",
    fill: "#DBE0D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisors);
export default __webpack_public_path__ + "static/media/advisors.c46825449cf89a4664d1566458cae97a.svg";
export { ForwardRef as ReactComponent };